import {
  WalkingFarmLeadStatusColorEnum,
  WalkingFarmLeadStatusEnum,
  WalkingFarmLeadStatusLabelEnum
} from '../enums/walking-farm';

export const walkingFarmAvailableLeadStatuses: {
  color: WalkingFarmLeadStatusColorEnum;
  label: WalkingFarmLeadStatusLabelEnum;
  value: WalkingFarmLeadStatusEnum;
}[] = [
  {
    color: WalkingFarmLeadStatusColorEnum.Lead,
    label: WalkingFarmLeadStatusLabelEnum.Lead,
    value: WalkingFarmLeadStatusEnum.Lead
  },
  {
    color: WalkingFarmLeadStatusColorEnum.Prospect,
    label: WalkingFarmLeadStatusLabelEnum.Prospect,
    value: WalkingFarmLeadStatusEnum.Prospect
  },
  {
    color: WalkingFarmLeadStatusColorEnum.NotHome,
    label: WalkingFarmLeadStatusLabelEnum.NotHome,
    value: WalkingFarmLeadStatusEnum.NotHome
  },
  {
    color: WalkingFarmLeadStatusColorEnum.NotContacted,
    label: WalkingFarmLeadStatusLabelEnum.NotContacted,
    value: WalkingFarmLeadStatusEnum.NotContacted
  },
  {
    color: WalkingFarmLeadStatusColorEnum.NotInterested,
    label: WalkingFarmLeadStatusLabelEnum.NotInterested,
    value: WalkingFarmLeadStatusEnum.NotInterested
  },
  {
    color: WalkingFarmLeadStatusColorEnum.OnMarket,
    label: WalkingFarmLeadStatusLabelEnum.OnMarket,
    value: WalkingFarmLeadStatusEnum.OnMarket
  }
];

export const defaultWalkingFarmRadius = 0.1;
